<template>
  <div class="online-cv-wrapper" :style="iosOrAndroidStyle">
    <w-nav-bar icon="' '"  @mobileLeftBtn="routerBack" v-show="iosOrAndroidShow"/>
    <div class="success-container flex-column-center">
      <span class="iconfont iconwancheng"/>
      <p class="title">已开启智能推荐</p>
      <p class="description">HR 可能对你发出职位邀请，可下载 App 查看消息</p>
    </div>
    <div class="online-footer footer">
      <button class="theme-button flex-center footer-button" @click="toCvs">完成</button>
    </div>
  </div>
</template>

<script>
	import WNavBar from '@/components/global/w-navbar'
	import { mapActions, mapState } from 'vuex'
	import { envMixin } from '../../assets/js/mixin/global'

	export default {
		name: 'cv-success',
		mixins: [ envMixin ],
		data () {
			return {}
		},
		mounted () {
			this._createOnlineCv()
		},
		computed: {},
		watch: {},
		components: {
			WNavBar
		},
		methods: {
			async _createOnlineCv () {
				let token = this.$route.params.online_token
				let res = await this.$api.online.createOnlineCv({ token })
			},
			toCvs () {
				this.routeTo('/cvs')
			},
			routerBack () {
				this.$router.back()
			},
			// 打开APP或者应用商店
			goToApp () {
				// iOS
				if (this.isIosBrowser) {
					// window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.wondercv';
						window.location.href = `https://www.wondercv.${ process.env.VUE_APP_ENV === 'local' ? 'cn' : 'com' }/wondercv_app/open_app`;
					// AndroidOS
				} else {
					// 调用安卓协议打开APP  没有安装APP则跳转应用宝
					window.location.href = 'android://h5/open'
					let t = Date.now();
					setTimeout(()=> {
						if (Date.now() - t < 1200) {
							if (this.isWxMini) {
                this.$router.push({ path: '/wondercv_app/open_app' })
							} else {
								window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.wondercv';
							}
						}
					}, 1000);
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/mixin';
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/cv/online-cv';
  .success-container {
    width: 100vw;
    position: fixed;
    top: 150px;
    .iconfont {
      color: $color-theme;
      font-size: 42px;
      margin-bottom: 26px;
    }
    .title {
      color: $color-title;
      font-size: $font-size-large-x;
      letter-spacing: 1px;
      line-height: 20px;
      font-weight: 500;
      margin-bottom: 12px;
    }
    .description {
      font-size: $font-size-medium-x;
      color: #9C9C9C;
      line-height: 22px;
    }
  }
</style>
